import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaBookOpen, FaChalkboardTeacher, FaWhatsapp } from 'react-icons/fa';
import styles from './pagina_nutri_marimurra.module.scss';
import Foto from './src/foto2.jpg';
import { WHATSAPP_ONLINE, getWhatsappUrl } from './dados_nutri_marimurra.ts';

type Publico = 'profissionais' | 'familias';

const CONTEUDO_PUBLICO: Record<
    Publico,
    { eyebrow: string; lead: string; cursos: string; aulas: string; publicoMensagem: string }
> = {
    profissionais: {
        eyebrow: 'Para profissionais de saúde e nutrição',
        lead: 'Formação com base científica para profissionais que atendem crianças e querem aprofundar o cuidado nutricional na infância.',
        cursos: 'Cursos e e-books para profissionais estão sendo preparados com muito carinho e em breve estarão disponíveis aqui.',
        aulas: 'Aulas sobre nutrição pediátrica, seletividade e terapia alimentar. As próximas datas serão divulgadas por aqui.',
        publicoMensagem: 'para profissionais de saúde e nutrição',
    },
    familias: {
        eyebrow: 'Para familiares e cuidadores',
        lead: 'Materiais leves e práticos para ajudar a família a construir uma relação mais tranquila com a alimentação das crianças.',
        cursos: 'Cursos e e-books para famílias estão sendo preparados com muito carinho e em breve estarão disponíveis aqui.',
        aulas: 'Aulas sobre alimentação infantil e seletividade alimentar no dia a dia. As próximas datas serão divulgadas por aqui.',
        publicoMensagem: 'para familiares e cuidadores',
    },
};

const Cursos_nutri_marimurra: React.FC<{ publico: Publico }> = ({ publico }) => {
    const conteudo = CONTEUDO_PUBLICO[publico];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [publico]);

    const materiais = [
        {
            titulo: 'Cursos e e-books',
            status: 'Em desenvolvimento',
            descricao: conteudo.cursos,
            icon: <FaBookOpen />,
        },
        {
            titulo: 'Aulas',
            status: 'Em breve',
            descricao: conteudo.aulas,
            icon: <FaChalkboardTeacher />,
        },
    ];

    return (
        <div className={styles.pagina_nutri_marimurra}>
            <div className={styles.page}>
                <div className={styles.headerNav}>
                    <Link to="/nutri_marimurra" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                </div>

                <img className={styles.heroImg} src={Foto} alt="Mariana Murra, nutricionista" />

                <p className={styles.eyebrow}>{conteudo.eyebrow}</p>
                <h1 className={styles.title}>Cursos e materiais</h1>
                <p className={styles.lead}>{conteudo.lead}</p>

                <div className={styles.section}>
                    <div className={styles.itemList}>
                        {materiais.map((item) => (
                            <div key={item.titulo} className={styles.item}>
                                <span className={styles.itemIcon}>{item.icon}</span>
                                <div>
                                    <span className={styles.badge}>{item.status}</span>
                                    <h2 className={styles.itemTitle}>{item.titulo}</h2>
                                    <p className={styles.paragraph}>{item.descricao}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.cta}>
                    <h2 className={styles.sectionTitle}>Quer ser avisado(a) do lançamento?</h2>
                    <p className={styles.paragraph}>Mande uma mensagem e receba as novidades em primeira mão.</p>
                    <div className={styles.ctaButtons}>
                        <a
                            href={getWhatsappUrl(
                                WHATSAPP_ONLINE,
                                `Olá, Mariana! Gostaria de ser avisado(a) quando os cursos e materiais ${conteudo.publicoMensagem} forem lançados.`
                            )}
                            className={`${styles.button} ${styles.buttonLight}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp aria-hidden />
                            Quero ser avisado(a)
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cursos_nutri_marimurra;
